export default class BlockService {
    constructor() {
        this.currentElements = [];    
    }

    add(name, element) {
        if (! this.getByName(name)) {
            this.currentElements.push({ name: name, block: element });
        }
    };

    get() {
        return this.currentElements;
    };

    getByName(name) {
        for (var key in this.currentElements) {
            if (this.currentElements[key].name === name) {
                return this.currentElements[key];
            }
        }
        
        return false;
    };

    clear() {
        this.currentElements.splice(0, this.currentElements.length);
    };

    count() {
        return this.currentElements.length;
    };
};
